import type { OsasRequestAdditionalExaminationData } from '@common/validation/customControls/osas/osasAdditionalExaminationSchema';

export const initialData: OsasRequestAdditionalExaminationData = {
    reasonChanged: null,
    sleepRecorderType: null,
};
